import 'js-breakpoints'

function showSecondLevelMenu(menuItemElement, menuList) {
    return function() {
        menuList.classList.add('c-navigation__list--is-active')
        menuItemElement.classList.add('c-navigation__item--open')
        const overlay = document.querySelector('.overlay')
        const header = document.querySelector('.c-header')
        if(overlay) {
            overlay.classList.add('overlay--visible')
        }
        if(header) {
            header.classList.add('c-header--highlight')
        }
    }
}

function hideSecondLevelMenu(menuItemElement, menuList) {
    return function() {
        menuList.classList.remove('c-navigation__list--is-active')
        menuItemElement.classList.remove('c-navigation__item--open')
        const overlay = document.querySelector('.overlay')
        const header = document.querySelector('.c-header')
        if(overlay) {
            overlay.classList.remove('overlay--visible')
        }
        if(header) {
            header.classList.remove('c-header--highlight')
        }
    }
}

function stopPropagationMenu(e) {
    if(e != null) {
        e.stopPropagation()
    }
}


function removeObscureSite() {
    const overlay = document.querySelector('.overlay')
    const header = document.querySelector('.c-header')
    if(overlay) {
        overlay.classList.remove('overlay--visible')
    }
    if(header) {
        header.classList.remove('c-header--highlight')
    }
}

function menuConfiguration(container, listItem) {
    if(listItem.length) {
        listItem.forEach((item) => {
            const secondLevelMenu = item.querySelector('.js-drop-down')
            const linkItem = item.querySelector('.c-navigation__link')
            if(secondLevelMenu != null) {
                // get the last link within the second level menu
                const secondLevelLinks = secondLevelMenu.querySelectorAll('a')
                const lastLinkIndex = secondLevelLinks.length - 1
                const lastLink = secondLevelLinks[lastLinkIndex]
                const showMegaMenu = showSecondLevelMenu(item, secondLevelMenu, container)
                const hideMegaMenu = hideSecondLevelMenu(item, secondLevelMenu, container)
                const stopProp = stopPropagationMenu(event)
                Breakpoints.on({
                    name: 'bp-medium',
                    matched: function() {
                        hideMegaMenu()
                        // hide second level menu if anything outside (document) the submenu (stop propagation) is clicked
                        document.addEventListener('click', hideMegaMenu, true)
                        secondLevelMenu.addEventListener('click', stopProp, true)
                        item.addEventListener('mouseover', showMegaMenu, true)
                        item.addEventListener('mouseout', hideMegaMenu, true)
                        linkItem.addEventListener('focus', showMegaMenu, true)
                        if(lastLink != null){
                            lastLink.addEventListener('blur',  hideMegaMenu, true)
                        }
                    },
                    exit: function() {
                        removeObscureSite()
                        document.removeEventListener('click', hideMegaMenu, true)
                        item.removeEventListener('mouseover', showMegaMenu, true)
                        item.removeEventListener('mouseout', hideMegaMenu, true)
                        linkItem.removeEventListener('focus', showMegaMenu, true)
                        if(lastLink != null){
                            lastLink.removeEventListener('blur',  hideMegaMenu, true)
                        }
                        secondLevelMenu.removeEventListener('click', stopProp, true)
                    }
                })
            }
        })
    }
}

export default menuConfiguration